/** In-memory sample athletes for admin overview visual QA. Never persisted. */
const STAGES = ["invited", "started", "siis_review", "athlete_approval", "ready", "published"] as const;
const TEAMS = ["Sample Waves", "Sample Comets", "Sample Storm"];
export const overviewFixture = (n: number) => {
  const rows: any[] = [], athletes: Record<string, any> = {}, teams: Record<string, string[]> = {};
  for (let i = 0; i < n; i++) {
    const id = `fx-${i}`;
    const stage = STAGES[i % STAGES.length];
    athletes[id] = {
      id, slug: id, name: `Sample Athlete ${String(i + 1).padStart(2, "0")}`, sport: "Football",
      tagline: i % 2 ? "Sample tagline" : null, bio: i % 3 ? "<p>Sample</p>" : null, image_path: i % 4 ? "x.jpg" : null,
      instagram_url: i % 2 ? "https://instagram.com/x" : null, published: stage === "published",
      owner_user_id: stage === "invited" && i % 2 ? null : "fixture", support_enabled: false,
    };
    teams[id] = [TEAMS[i % TEAMS.length]];
    rows.push({
      athlete_id: id, stage, quick_start_submitted_at: STAGES.indexOf(stage) >= 2 ? "2026-10-01" : null,
      module_choices: i % 5 === 0 ? { her_collection: "interested" } : {}, changes_requested: null,
      approved_at: STAGES.indexOf(stage) >= 4 ? "2026-10-02" : null, approved_current_version: STAGES.indexOf(stage) >= 4,
      consent_profile: STAGES.indexOf(stage) >= 4, consent_likeness: STAGES.indexOf(stage) >= 4,
      follower_count: (i * 7) % 23, open_inquiries: i % 6 === 0 ? 1 : 0, claim_link_status: null,
    });
  }
  return { rows, athletes, teams };
};
